// Copyright 2020 Cartesi Pte. Ltd.
export const maps = () => require('./resources/maps.json');
export const loadMap = (name) => {
    try {
        return require(`./maps/${name}.json`);
    }
    catch (err) {
        if (err.code === 'MODULE_NOT_FOUND') {
            return undefined;
        }
        else {
            throw err;
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21hcC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxtQ0FBbUM7QUFjbkMsTUFBTSxDQUFDLE1BQU0sSUFBSSxHQUFHLEdBQWEsRUFBRSxDQUFDLE9BQU8sQ0FBQyx1QkFBdUIsQ0FBQyxDQUFDO0FBRXJFLE1BQU0sQ0FBQyxNQUFNLE9BQU8sR0FBRyxDQUFDLElBQVksRUFBeUIsRUFBRTtJQUMzRCxJQUFJO1FBQ0EsT0FBTyxPQUFPLENBQUMsVUFBVSxJQUFJLE9BQU8sQ0FBQyxDQUFDO0tBQ3pDO0lBQUMsT0FBTyxHQUFHLEVBQUU7UUFDVixJQUFJLEdBQUcsQ0FBQyxJQUFJLEtBQUssa0JBQWtCLEVBQUU7WUFDakMsT0FBTyxTQUFTLENBQUM7U0FDcEI7YUFBTTtZQUNILE1BQU0sR0FBRyxDQUFDO1NBQ2I7S0FDSjtBQUNMLENBQUMsQ0FBQyJ9